import ReactSelect from 'react-select';
import { cx } from '@linaria/core';
import { IconChevronDown } from 'components/Icons';
import { dropdownIcon, selectControl, selectOption, selectValueContainer, wrapper } from './styles';
import { SelectProps } from './types';

// Ideally, we should have a single `Select` for the entire project. Unfortunately, this is not
// the case and we have more than 3 from different libraries! In the future, it would be good to refactor
// different parts of the app to use either this component or another that we decide.
export const Select = <T,>({ containerClassName, controlClassName, onKeyDown, ...selectProps }: SelectProps<T>) => (
  <div className={wrapper}>
    <ReactSelect
      {...selectProps}
      classNames={{
        ...selectProps.classNames,
        container: () => cx(containerClassName),
        control: ({ isFocused }) => cx(selectControl, isFocused && 'active', controlClassName),
        valueContainer: () => selectValueContainer,
        option: () => selectOption,
      }}
      components={{
        // TODO: This is not correct because we are creating the component on every render. Unfortunately,
        // react-select doesn't have a way to provide props to custom components from its parent.
        DropdownIndicator: () => <IconChevronDown className={dropdownIcon} size={20} />,
        ...selectProps.components,
        IndicatorSeparator: null,
      }}
      onKeyDown={onKeyDown}
    />
  </div>
);
